import { BBSpinner } from '../BBSpinner/BBSpinner';
import { CircularLoading } from '../CircularLoading/CircularLoading';
import Flex from '../Flex/Flex';
import { PageContent } from '../PageContent/PageContent';

export interface LoadingFallbackProps {
  isBlue?: boolean;
  fullPage?: boolean;
}

export const LoadingFallback = ({ isBlue = false, fullPage = false }: LoadingFallbackProps) => {
  if (fullPage) {
    return <CircularLoading />;
  }

  return (
    <PageContent isBlue={isBlue}>
      <Flex
        sx={{
          height: '100%',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
        }}
      >
        <BBSpinner size="md" />
      </Flex>
    </PageContent>
  );
};
